import { graphql } from "react-relay";

export const PRODUCT_FRAGMENT = graphql`
	fragment productPriceColumn_ProductFragment on Product {
		netPrice
	}
`;
